import { useTranslation } from 'react-i18next'
import { UITooltipHelpIcon } from '../HelpIcon'
import MarkdownRenderer from '../ui/MarkdownRenderer'

export const QuotaHelpIcon = ({ className }: { className?: string }) => {
  const { t } = useTranslation(['generation'])

  return (
    <UITooltipHelpIcon variant="normal" iconClassName={className}>
      <MarkdownRenderer className="flex flex-col prose dark:prose-invert">
        {t('generation:generation.quota-help.content')}
      </MarkdownRenderer>
    </UITooltipHelpIcon>
  )
}
